/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var PermitAction;
(function (PermitAction) {
    PermitAction[PermitAction["Create"] = 1] = "Create";
    PermitAction[PermitAction["Read"] = 2] = "Read";
    PermitAction[PermitAction["Update"] = 3] = "Update";
    PermitAction[PermitAction["Delete"] = 4] = "Delete";
})(PermitAction || (PermitAction = {}));
